import React from 'react';

const HeaderSocials = () => {
    return (
        <>
            <div className="home__socials">
                <p className="home__socials">Lorem ipsum dolor sit amet consectetuer adipiscing elit         aenean commodo ligula eget.
                    Lorem ipsum dolor sit amet consectetuer adipiscing elit         aenean commodo ligula eget.
                </p>
            </div>

        </>
    );
};

export default HeaderSocials;